/* eslint-disable react-hooks/exhaustive-deps */

import { useLocation } from "react-router-dom";
import { LoadingIcon } from "utils/constant";
import SingleAdvocateAppealForRegional from "./SingleAdvocateAppealForRegional";
import SingleAdvocateAppealForZonal from "./SingleAdvocateAppealForZonal";

export default function SingleAdvocateAppeal() {
  const { state } = useLocation();

  if (!state)
    return (
      <div className="flex justify-center items-center h-96">{LoadingIcon}</div>
    );

  return state?.is_regional ? (
    <SingleAdvocateAppealForRegional />
  ) : (
    <SingleAdvocateAppealForZonal />
  );
}
